<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Cliente
						<template v-if="$platform.setting.customers.custom_reference">
							Ref. {{ data.reference }}
						</template>
						<template v-else>
							{{ $platform.setting.number_symbol }}{{ data.id }}
						</template>
					</h4>
				</div>
				<div class="list-group m-b-0">
					<router-link
						@click.native="close"
						class="list-group-item"
						:to="goTo('customers/' + data.id)">
						<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
						Ver 
					</router-link>

					<router-link @click.native="close" :to="goTo('customers/'+ data.id +'/edit')" class="list-group-item">
						<i class="ti-pencil-alt fa-fw"></i>
						Editar 
					</router-link>
					<template v-if="user.hasRole('admin')">
						<button @click="destroy(data)" type="button" class="list-group-item" :disabled="data.projects_count > 0">
							<i class="icon-trash fa-fw"></i>
							Eliminar
						</button>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'customers-actions-' + new Date().getTime(),
				},

				data: null
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				} else {
					this.data = null
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/' + to
					}
				} else {
					var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
				}

				return to
			},
			destroy(data) {
				this.close()
				this.$emit('destroy', data)
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Actions.vue